module.exports = __webpack_public_path__ + "media/img/scholarship_types/Unusual Scholarships-72a644e089823521431b83859b920f23.svg";